import { OrderBookingMode } from '@vista-digital/ocapi-types/v1';
export const defaultOrderSelections = {
    bookingMode: OrderBookingMode.Paid,
    showtime: undefined,
    items: undefined,
    itemDeliveriesComment: undefined,
    subscription: undefined,
    tip: undefined,
    siteId: undefined
};
//# sourceMappingURL=order-selections.js.map